module.exports = __webpack_public_path__ + "static/media/dietetic-app-reference-list.40d2db03.pdf";